import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';
import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthGuard} from './shared/auth/auth-guard.service';
import { CountryBalanceComponent } from './country-balance/country-balance.component';

const AppRoutes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'profile',
        loadChildren: './profile/profile.module#ProfileModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'parameters',
        loadChildren: './parameters/parameters.module#ParametersModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'organizations',
        loadChildren: './organization/organization.module#OrganizationModule',
        data: {permission: 'CLK-ORGA-GET' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'agencies',
        loadChildren: './agency/agency.module#AgencyModule',
        data: {permission: 'CLK-AGEN-GET' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'users',
        loadChildren: './users/users.module#UsersModule',
        data: {permission: 'CLK-USOP-GET' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'customers',
        loadChildren: './customer/customer.module#CustomerModule',
        data: {permission: 'CLK-CUST-GET', customerType: 'customer' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'collects',
        loadChildren: './customer/customer.module#CustomerModule',
        data: {permission: 'CLK-USCOL-GET', customerType: 'collect' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'call-centers',
        loadChildren: './call-center/call-center.module#CallCenterModule',
        data: {permission: 'CLK-CACE-GET' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'operations',
        loadChildren: './operation/operation.module#OperationModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'reports',
        loadChildren: './report/report.module#ReportModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'logs',
        loadChildren: './log/log.module#LogModule',
        data: {permission: 'CLK-CUST-GET' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'deposit-account-operations',
        loadChildren: './deposit-account/deposit-account.module#DepositAccountModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'cashout',
        loadChildren: './cashout/cashout.module#CashoutModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'commission-accounts',
        loadChildren: './commission-account/commission-account.module#CommissionAccountModule'
      }
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './session/session.module#SessionModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts